import type { WorkflowTriggerType } from "@babackapp/variables-registry";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";

export function useTriggerType(): WorkflowTriggerType {
  const form = useWorkflowForm();
  return form.watch("workflow.trigger.data.triggerType") as WorkflowTriggerType;
}
